const messages = {
  title: "Benvenuto in BRIDGESTONE <span class='text-danger'>PLUS</span>",
  description:
    "Accedere con l'indirizzo e-mail e la password.<br/><br/><b>Sei nuovo qui?</b><br/><br/>Creare quindi un nuovo account utente utilizzando la funzione REGISTRAZIONE.<br/><br/>Verrà quindi effettuato automaticamente l'accesso.",
  info: "",
  buttons: {
    action: "Accedi / Registrati",
    back: "Torna al login",
    changeLanguage: "Cambia lingua",
    start: "Inizia",
  },
  languageSelect: {
    label: "Selezione della lingua",
    description: "Seleziona la tua lingua",
    start: {
      deCH: "Tedesco",
      frCH: "Francese",
      itCH: "Italiano",
    },
  },
};

export default {
  messages,
};
